import { Skeleton } from '@mui/material';
import { Box, Text } from '@src/shared/ui';
import React from 'react';

type FlightDetailsProps = {
  title: string;
  from: string;
  to: string;
  isReturn?: boolean;
  only?: boolean;
  loading?: boolean;
  desktop?: boolean;
  isModal?: boolean;
  notIcon?: boolean;
};

export const FlightDetails: React.FC<FlightDetailsProps> = ({
  title,
  from,
  notIcon,
  to,
  desktop,
  loading,
  isReturn,
  only,
  isModal,
}) => {
  const loadingPlane = () => (
    <Skeleton
      variant='rounded'
      height={24}
      width={24}
      className='mr-3 sm:mr-4'
    />
  );

  type loadingTextProps = {
    className?: string;
    width?: number;
  };

  const loadingText = ({ className, width }: loadingTextProps) => (
    <Skeleton
      variant='rounded'
      height={24}
      width={`${width}%`}
      className={className}
    />
  );

  return (
    <Box
      className={`
      flex
      flex-row
      items-start
      ${!isReturn && !desktop ? (only ? '' : 'pb-4 sm:pb-6') : ''}
      ${!isReturn && desktop && only ? 'pb-4 sm:pb-6' : ''}
      ${isReturn && !desktop ? 'pt-6' : ''}
      ${loading && isReturn ? 'pt-6' : ''}
      ${isReturn && !desktop && !only ? 'mt-6 border-solid border-t-[1px] border-[#E1E4E6]' : ''}
    `}
    >
      {loading ? (
        loadingPlane()
      ) : notIcon ? null : (
        <img
          src='/plane.svg'
          className={`mr-3 sm:mr-4 ${isReturn ? 'rotate-180' : ''} ${isModal && desktop ? '-z-20' : ''} ${isModal && !desktop ? 'z-30' : ''}`}
          alt='Plane icon'
        />
      )}
      <Box
        className={`
        flex-1
        ${isReturn && desktop ? 'pb-6' : ''}
        ${!isReturn && !desktop ? (only ? '' : 'pb-4 sm:pb-6') : ''}
      `}
      >
        {loading ? (
          loadingText({})
        ) : (
          <Text
            className={`leading-6 font-semibold text-neutral-70 ${loading ? 'flex flex-row' : ''}`}
          >
            {isReturn ? 'Voo de volta - ' : 'Voo de ida - '}
            {title}
          </Text>
        )}
        {loading ? (
          loadingText({ className: 'mt-2', width: 50 })
        ) : (
          <Text
            className={`text-sm sm:text-base text-neutral-50 mt-2 ${loading ? 'flex flex-row gap-[13px]' : ''}`}
          >
            De: {from}
          </Text>
        )}
        {loading ? (
          loadingText({ className: 'mt-1', width: 50 })
        ) : (
          <Text
            className={`text-sm sm:text-base text-neutral-50 mt-1 ${loading ? 'flex flex-row' : ''}`}
          >
            Para: {to}
          </Text>
        )}
      </Box>
    </Box>
  );
};
